export default "__VITE_ASSET__DO9xoJfl__"